import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { getGuessURL } from '@/utils/helpers';

export const NoBillingReminderTemplate = () => {
  const { t } = useTranslation();

  return (
    <>
      <span>{t('PrivateLayout.reminderBodyNewFree')} </span>
      <a
        title="Payments"
        href={getGuessURL()}
        className="underline text-md-links hover:text-md-linksAlt"
      >
        {t('PrivateLayout.reminderNoBillingNewFree')}
      </a>
    </>
  );
};
